import { Route, Routes, Navigate } from "react-router-dom";

import { DashboardWrapper } from "../pages/dashboard/DashboardWrapper";
import { AttendanceRoutes } from "@/pages/AttendanceRoutes";
import { MasterLayout } from "@/../_metronic/layout/MasterLayout";
import { HospitalizationPermitsManagement } from "@/pages/HospitalizationPermitsManagement";
import { HospitalizationPermitsInformation } from "@/pages/HospitalizationPermitsInformation";
import { SurgicalCenter } from "@/pages/SurgicalCenter";

const PrivateRoutes = () => {
	return (
		<Routes>
			<Route element={<MasterLayout />}>
				<Route path="auth/*" element={<Navigate to="/centro-cirurgico" />} />

				{/* tabs */}
				<Route path="dashboard" element={<DashboardWrapper />} />
				<Route path="centro-cirurgico" element={<SurgicalCenter />} />

				<Route path="atendimento/:attendanceId/*" element={<AttendanceRoutes />} />

				<Route path="gerenciamento-aih/*" element={<HospitalizationPermitsManagement />} />

				<Route path="informacoes-aih/*" element={<HospitalizationPermitsInformation />} />

				{/* Page Not Found */}
				<Route path="*" element={<Navigate to="/error/404" />} />
			</Route>
		</Routes>
	);
};

export { PrivateRoutes };
